"use strict";

const {
  sectionId
} = document.currentScript.dataset;
const pageViewId = window.uuidv1();
let midasPositions = [];
let showMidas = false;
let sessionId = '';
function getCards(cardTypesById) {
  let cardTypeQueryParams = '';
  cardTypesById.forEach(cardType => {
    cardTypeQueryParams += `&card_type_id=${cardType}`;
  });
  return cardTypeQueryParams;
}
function impressionCounter(url) {
  fetch(url, {
    method: 'GET'
  });
}
function countMidasCardImpression(midasDataToShow, midasItem) {
  const linkForImpressionCount = midasDataToShow.viewable_impression_url;
  if (linkForImpressionCount) {
    if (window.isInViewport(midasItem)) {
      impressionCounter(linkForImpressionCount);
    } else {
      const controller = new AbortController();
      window.addEventListener('scroll', window.debounce(() => {
        if (window.isInViewport(midasItem)) {
          impressionCounter(linkForImpressionCount);
          controller.abort();
        }
      }, 10), {
        passive: true,
        signal: controller.signal
      });
    }
  }
}
function fillMidasEngagementBarWithData(midasItem, internalLink, midasDataToShow) {
  const engagementBar = midasItem.querySelector('.js_midas_engagement_bar');
  if (!internalLink) {
    midasItem.classList.add('card__midas', 'is-section-exchange');
    engagementBar?.setAttribute('style', 'display: none;');
    const videoLabel = midasItem.querySelector('span.card__video_time');
    videoLabel?.setAttribute('style', 'display: none;');
  } else if (engagementBar) {
    const midasArticleId = midasDataToShow.pub_article_id;
    engagementBar.classList.add(`engagement_detail_${midasArticleId}`);
    midasItem.querySelector('.engagement_bar__meta_item_wrap span[role="button"]')?.setAttribute('onclick', `showReactionTooltip(this, '${midasArticleId}')`);
    engagementBar.dataset.articleId = midasArticleId;
    midasItem.querySelector('.engagement_bar__meta_item--share')?.setAttribute('onclick', `toggleShareTooltip('${midasArticleId}')`);
    window.commonEngagementLogic(midasArticleId, engagementBar.dataset.ownReactionSlug || null, true, 'articles');
    const sendReactionButtons = midasItem.querySelectorAll('.reactions_wrapper span[role="button"]');
    sendReactionButtons.forEach(button => {
      const buttonDataToSend = button.getAttribute('onclick').replace('"', "'").split("sendReaction('")[1].split("', '");
      const reactionId = buttonDataToSend[0];
      const reactionSlug = buttonDataToSend[1];
      const reactionContentType = buttonDataToSend[2];
      button.setAttribute('onclick', `sendReaction('${reactionId}', '${reactionSlug}', '${reactionContentType}', '${midasArticleId}')`);
    });
    const shareBar = engagementBar.querySelector('.share_bar');
    const shareBarItems = shareBar?.querySelectorAll('.share_bar__item_wrap a');
    shareBarItems.forEach(item => {
      if (item.href) {
        const itemHref = item.href.split('https://www.24sata.hr')[0];
        item.href = `${itemHref}${midasDataToShow.link}`;
        if (item.href.includes('twitter')) item.href += `&via=24sata_hr&text=${midasDataToShow.title}`;
      } else if (item.dataset.viberText) {
        item.dataset.viberText = `${midasDataToShow.title} ${midasDataToShow.link}`;
        item.setAttribute('href', window.generateViberLink(item.dataset.viberText));
      }
    });
    engagementBar.querySelector('.share_bar__item_wrap--copy')?.setAttribute('onclick', `copyLink('${midasArticleId}')`);
    const copyLink = engagementBar.querySelector('.js_copyLink');
    if (copyLink) {
      copyLink.id = `copyLink-${midasArticleId}`;
      copyLink.value = midasDataToShow.link;
      copyLink.setAttribute('value', copyLink.value);
      copyLink.classList.remove('no-id');
    }
  }
  midasItem.dataset.cardUsed = true;
  midasItem.setAttribute('style', 'display: block;');
  countMidasCardImpression(midasDataToShow, midasItem);
}
function clickCount(e) {
  fetch(e).then(() => console.info('Successfully called click counting route')).catch(() => console.error('Failed to call the click counting route'));
}
function fillMidasCardsWithData(midasItem, midasDataToShow) {
  const internalLink = midasDataToShow.link.startsWith('https://www.24sata.hr');
  const aElement = midasItem.querySelector('.card__link');
  if (aElement) {
    aElement.setAttribute('href', midasDataToShow.link);
    aElement.setAttribute('title', midasDataToShow.title || '');
    aElement.setAttribute('target', internalLink ? '_self' : '_blank');
    const imgElement = aElement.querySelector('.card__video_fallback_image');
    if (imgElement) {
      imgElement.setAttribute('src', midasDataToShow.cover_image_url || '');
      imgElement.setAttribute('alt', midasDataToShow.title || '');
    }
    aElement.querySelector('.card__label').innerHTML = midasDataToShow.label || '';
    aElement.querySelector('.card__title').innerHTML = midasDataToShow.title || '';
  }
  const clickUrl = midasDataToShow.click_url;
  if (clickUrl) {
    // Click count route call - for left click
    midasItem.addEventListener('click', () => {
      clickCount(clickUrl);
    });

    // Click count route call - for right click
    midasItem.addEventListener('contextmenu', () => {
      clickCount(clickUrl);
    });
  }
  fillMidasEngagementBarWithData(midasItem, internalLink, midasDataToShow);
}
function resolveMidasCardId(midasCardType) {
  return isNaN(parseInt(midasCardType)) ? window.midasCardTypesMap[midasCardType] : parseInt(midasCardType);
}
function processMidas(midasCards) {
  midasPositions.forEach(midasItem => {
    const {
      midasCardType
    } = midasItem.dataset;
    const midasCardData = midasCards.filter(card => card.card_type_id === resolveMidasCardId(midasCardType));
    if (!midasCardData.length) return;
    const midasDataToShow = midasCardData[0];
    midasCards.forEach((e, i) => {
      if (e.link === midasDataToShow.link) midasCards.splice(i, 1);
    });
    fillMidasCardsWithData(midasItem, midasDataToShow);
  });
}
async function getMidasCardsData(feed) {
  let midasUserId = '';
  if (typeof window.getMidasUserId === 'function') {
    midasUserId = window.getMidasUserId() || '';
  }
  if (!feed) midasPositions = document.querySelectorAll('.js_midasCard');
  if (midasPositions.length) {
    const cardTypesById = [];
    midasPositions.forEach(e => {
      const {
        midasCardType
      } = e.dataset;
      cardTypesById.push(resolveMidasCardId(midasCardType));
    });
    if (cardTypesById.length && sectionId) {
      const url = new URL(`${window.MIDAS_URL}${sectionId}`);
      url.searchParams.append('portal_widget_id', '893');
      url.href += getCards(cardTypesById);
      if (pageViewId) url.searchParams.append('page_view_id', pageViewId);
      if (sessionId) url.searchParams.append('session_id', sessionId);
      if (midasUserId) url.searchParams.append('midas_user_id', midasUserId);
      url.searchParams.append('api_version_id', '2');
      try {
        const midasResponse = await fetch(url, {
          method: 'GET'
        });
        if (midasResponse.status === 200) {
          const midasResponseData = await midasResponse.json();
          sessionId = midasResponseData?.session_id;
          const midasCards = [];
          midasCards.push(...midasResponseData?.ordered_cards);
          if (midasCards.length) processMidas(midasCards);
        } else {
          console.error(`[Midas] '${url}' returned status 400, please check response:\n`, midasResponse);
        }
      } catch (error) {
        console.error(`[Midas] Fetching '${url}' resulted with error! \n`, error);
      }
    }
  }
}
window.initFeedMidas = () => {
  if (showMidas) {
    const feedMidasCards = document.querySelector('#feedPagesPrevious')?.querySelectorAll('.js_midasCard');
    midasPositions = Array.from(feedMidasCards).filter(e => e.dataset.cardUsed !== 'true');
    if (midasPositions.length) getMidasCardsData(true);
  }
};
document.addEventListener('BaseDataLoaded', () => {
  showMidas = window.getSettingsFromApi('midas_feed');
  if (showMidas) {
    getMidasCardsData();
  }
});